/** "24:00" closes a day; users also type it as "24" or "2400". */
export const END_OF_DAY_TIME = "24:00";
export const END_OF_DAY_ALIASES: readonly string[] = [END_OF_DAY_TIME, "24", "2400"];
export const HOURS_PER_DAY = 24;
/** Length of "HH:mm". */
export const TIME_TEXT_LENGTH = 5;
